import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "about"
};
const _hoisted_2 = {
  class: "bg-white m-2 rounded-lg p-4"
};
const _hoisted_3 = {
  class: "text-lg mb-3 font-medium"
};
const _hoisted_4 = {
  style: {
    "color": "#f66636"
  }
};
const _hoisted_5 = {
  class: "text-center pb-8"
};
import router from '@/router';
import { useStore } from '@/stores/pinia';
import { Toast } from 'vant';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'PoWa',
  setup(__props) {
    const store = useStore();
    const balance = computed(() => {
      return store.getBalance('pw');
    });
    const canSubmit = computed(() => {
      const {
        soul,
        amount,
        repeat
      } = store.pw;
      return soul && amount && repeat;
    });
    const clickSubmit = () => {
      if (balance.value < 0) return Toast.fail('余额不足');
      store.pw.isFinished = true;
      Toast.success({
        message: '提交成功',
        duration: 1000,
        onClose: router.back
      });
    };
    return (_ctx, _cache) => {
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_form = _resolveComponent("van-form");
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_nav_bar, {
        title: "破瓦",
        "left-arrow": "",
        onClickLeft: _unref(router).back
      }, null, 8, ["onClickLeft"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("h1", _hoisted_3, [_createTextVNode(" 破瓦金额：¥ "), _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(balance)), 1), _createTextVNode(" 元 ")]), _createVNode(_component_van_form, {
        class: "p-0"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell_group, {
          inset: "",
          class: "m-0"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_field, {
            required: "",
            modelValue: _unref(store).pw.soul,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(store).pw.soul = $event),
            name: "soul",
            label: "超度对象",
            placeholder: "请填写超度对象",
            rules: [{
              required: true,
              message: '请填写超度对象'
            }],
            maxlength: "30"
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            required: "",
            modelValue: _unref(store).pw.amount,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(store).pw.amount = $event),
            type: "number",
            name: "amount",
            label: "每天金额",
            placeholder: "请填写每天金额",
            rules: [{
              required: true,
              message: '请填写每天金额'
            }, {
              validator: v => v >= 1,
              message: '每天破瓦金额最小为1元'
            }]
          }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_field, {
            required: "",
            modelValue: _unref(store).pw.repeat,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(store).pw.repeat = $event),
            name: "repeat",
            type: "number",
            label: "重复天数",
            placeholder: "请填写重复天数",
            rules: [{
              required: true,
              message: '请填写重复天数'
            }]
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_button, {
        class: "submitBtn rounded-lg mt-4",
        color: "linear-gradient(45deg, #9C071E 0%, #F76F34 100%)",
        size: "large",
        disabled: !_unref(canSubmit),
        onClick: clickSubmit
      }, {
        default: _withCtx(() => [_createTextVNode(" 提交 ")]),
        _: 1
      }, 8, ["disabled"])])]);
    };
  }
});